import Preact, { Component, ErrorInfo } from 'preact';
import { LoadingScreenError } from '@dora/components';
import { AppControlContext } from '../context/appControl';
import * as Hooks from 'preact/hooks';
import { TranslateContext } from '@denysvuika/preact-translate';
import { connect, ConnectedProps } from 'react-redux';
import * as ConfigurationActions from '../../store/actions/configuration';
import { AnyAction, Dispatch } from 'redux';
import { logError } from '../../store/actions/logging';

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return {
        reportError: (message: string) => {
            dispatch(ConfigurationActions.errorAction({ reason: message, type: 'catch all' }));
        },
        logError: (message: string, context?: any) => {
            dispatch(logError(message, context));
        },
    };
};

const connector = connect(null, mapDispatchToProps);

type Props = ConnectedProps<typeof connector>;

interface ErrorState {
    error: boolean;
}

class ErrorBoundary extends Component<Props, ErrorState> {
    constructor(props: Props) {
        super(props);
        this.state = { error: false };
    }

    static getDerivedStateFromError() {
        return { error: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.props.logError(
            `Unexpected error: ${error.name}: ${error.message} has occurred in the following component: ${errorInfo.componentStack}`,
        );

        this.props.reportError(error.message);
    }

    render() {
        const appControl = Hooks.useContext(AppControlContext);
        const { t } = Hooks.useContext(TranslateContext);

        if (this.state.error) {
            return (
                <LoadingScreenError.Component
                    onClose={() => appControl?.closeApp()}
                    heading={t('i18n.global.unknownErrorHeading')}
                    body={t('i18n.configuration.unknownErrorBody')}
                />
            );
        }
        return this.props.children;
    }
}

export default connect(null, mapDispatchToProps)(ErrorBoundary as any);
